import { Directive } from '@angular/core';

@Directive({ selector: '[appTableRowLabelTemplate]' })
export class TableRowLabelTemplateDirective { }
